module.exports = __webpack_public_path__ + "img/icon_checked.ee209ed7.svg";